import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { installZodErrorMap } from './zod-error-map'

// ── Russian ─────────────────────────────────────────────
import ruCommon from '@/locales/ru/common.json'
import ruAuth from '@/locales/ru/auth.json'
import ruOnboarding from '@/locales/ru/onboarding.json'
import ruValidation from '@/locales/ru/validation.json'
import ruNav from '@/locales/ru/nav.json'
import ruDeals from '@/locales/ru/deals.json'
import ruProperties from '@/locales/ru/properties.json'
import ruRent from '@/locales/ru/rent.json'
import ruContacts from '@/locales/ru/contacts.json'
import ruCurrencies from '@/locales/ru/currencies.json'
import ruPlatforms from '@/locales/ru/platforms.json'
import ruTenants from '@/locales/ru/tenants.json'
import ruFinances from '@/locales/ru/finances.json'
import ruDocuments from '@/locales/ru/documents.json'
import ruSettings from '@/locales/ru/settings.json'
import ruDashboard from '@/locales/ru/dashboard.json'
import ruTasks from '@/locales/ru/tasks.json'
import ruAdmin from '@/locales/ru/admin.json'

// ── English ─────────────────────────────────────────────
import enCommon from '@/locales/en/common.json'
import enAuth from '@/locales/en/auth.json'
import enOnboarding from '@/locales/en/onboarding.json'
import enValidation from '@/locales/en/validation.json'
import enNav from '@/locales/en/nav.json'
import enDeals from '@/locales/en/deals.json'
import enProperties from '@/locales/en/properties.json'
import enRent from '@/locales/en/rent.json'
import enContacts from '@/locales/en/contacts.json'
import enCurrencies from '@/locales/en/currencies.json'
import enPlatforms from '@/locales/en/platforms.json'
import enTenants from '@/locales/en/tenants.json'
import enFinances from '@/locales/en/finances.json'
import enDocuments from '@/locales/en/documents.json'
import enSettings from '@/locales/en/settings.json'
import enDashboard from '@/locales/en/dashboard.json'
import enTasks from '@/locales/en/tasks.json'
import enAdmin from '@/locales/en/admin.json'

i18n.use(initReactI18next).init({
	resources: {
		ru: {
			translation: {
				...ruCommon, ...ruAuth, ...ruOnboarding, ...ruValidation, ...ruNav,
				...ruDeals, ...ruProperties, ...ruRent, ...ruContacts,
				...ruCurrencies, ...ruPlatforms, ...ruTenants, ...ruFinances, ...ruDocuments, ...ruSettings, ...ruDashboard, ...ruTasks, ...ruAdmin,
			},
		},
		en: {
			translation: {
				...enCommon, ...enAuth, ...enOnboarding, ...enValidation, ...enNav,
				...enDeals, ...enProperties, ...enRent, ...enContacts,
				...enCurrencies, ...enPlatforms, ...enTenants, ...enFinances, ...enDocuments, ...enSettings, ...enDashboard, ...enTasks, ...enAdmin,
			},
		},
	},
	lng: 'ru',
	fallbackLng: 'ru',
	interpolation: { escapeValue: false },
})

// Installed alongside i18n so validation and interface copy come up together;
// main.tsx already imports this module for its side effect.
installZodErrorMap()

export default i18n
